import { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import BannerCarousel from "../components/home/BannerCarousel";
import OurIdentitySection from "../components/home/OurIdentitySection";
import OurCapabilitiesSection from "../components/home/OurCapabilitiesSection";
import GrowthAndCareersSection from "../components/home/GrowthAndCareersSection";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page Metadata */}
      <Helmet>
        <title>DTS - Empowering Digital Transformation Associates</title>
        <meta name="description" content="Digital Transformation Associates" />
        <meta name="keywords" content="Digital Transformation Associates" />
        <meta name="author" content="Digital Transformation Associates" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charset="UTF-8" />

        {/* Open Graph Metadata */}
        <meta
          property="og:title"
          content="DTS - Empowering Digital Transformation Associates"
        />
        <meta
          property="og:description"
          content="Digital Transformation Associates"
        />
        <meta
          property="og:url"
          content="https://www.digitalTransformationAssociates.in/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content=""
        />
      </Helmet>

      {/* Page Content */}
      <Fragment>
        <BannerCarousel />
        <OurIdentitySection/>
        <OurCapabilitiesSection/>
        <GrowthAndCareersSection/>
      </Fragment>
    </>
  );
};

export default HomePage;
